module.exports = __webpack_public_path__ + "static/media/our-comp-img-CDM.124aa087.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/our-companies/our-comp-img-CDM.png
// module id = 326
// module chunks = 0